(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
  let designers = [];
  try { designers = JSON.parse(document.getElementById('AfDesigners')?.textContent || '[]'); } catch (_) {}
  const alias = { dior: 'christian dior', ysl: 'yves saint laurent', 'saint laurent': 'yves saint laurent', 'louis vuitton': 'louis vuitton' };
  document.querySelectorAll('[data-af-search]').forEach(form => {
    const input = form.querySelector('[data-search-input]');
    if (input.value.includes('title:')) input.value = input.value.replace(/tag:"[^"]*"\s*AND\s*/g, '').replace(/title:/g, '').replace(/\bAND\b/g, ' ').replace(/"/g, '').replace(/\s+/g, ' ').trim();
    form.addEventListener('submit', event => {
      const query = input.value.trim();
      if (!query) { event.preventDefault(); input.focus(); return; }
      const normalized = normalize(query);
      const exact = designers.find(item => normalize(item.name) === (alias[normalized] || normalized));
      const designer = exact || [...designers].sort((a,b) => b.name.length-a.name.length).find(item => (' '+normalized+' ').includes(' '+normalize(item.name)+' '));
      const expandedQuery = query.replace(/\bYSL\b/gi, 'Saint Laurent');
      const words = expandedQuery.replace(/[():"\\]/g, ' ').trim().split(/\s+/).filter(Boolean).slice(0,12);
      const textQuery = words.map(word => 'title:"' + word + '"').join(' AND ');
      input.value = designer && normalize(designer.name) === 'chanel' ? 'tag:"Chanel" AND ' + textQuery : textQuery;
    });
  });
  document.querySelectorAll('[data-designer-find]').forEach(input => input.addEventListener('input', () => {
    const needle = normalize(input.value);
    document.querySelectorAll('[data-designer-link]').forEach(link => { link.hidden = !normalize(link.textContent).includes(needle); });
  }));
  document.querySelectorAll('.nav-dropdown').forEach(details => details.addEventListener('toggle', () => {
    if (details.open) document.querySelectorAll('.nav-dropdown').forEach(other => { if (other !== details) other.open = false; });
  }));
  document.addEventListener('click', event => { if (!event.target.closest('.nav-dropdown')) document.querySelectorAll('.nav-dropdown').forEach(el => { el.open = false; }); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.nav-dropdown[open]').forEach(el => { el.open = false; el.querySelector('summary').focus(); }); });
  const variants = document.querySelector('[data-variant-select]');
  if (variants) variants.addEventListener('change', () => {
    const option = variants.selectedOptions[0], button = document.querySelector('[data-add-button]');
    document.querySelector('[data-variant-price]').textContent = option.dataset.price;
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? button.dataset.soldText : button.dataset.addText;
    const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
  });
  const mq = matchMedia('(max-width: 700px)');
  const drawer = document.querySelector('.filter-drawer');
  if (drawer) { drawer.open = !mq.matches; mq.addEventListener('change', () => { drawer.open = !mq.matches; }); }
})();
